import { combineReducers } from "redux";

import { connectRouter } from "connected-react-router";

import { reducer as formReducer } from "redux-form";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import Geral from "ducks/Geral";
import Auth from "ducks/Auth";
import Logo from "ducks/Logo";
import Dashboard from "ducks/Dashboard";
import Motoristas from "ducks/Motoristas";
import Remetentes from "ducks/Remetentes";
import Romaneios from "ducks/Romaneios";
import Cte from "ducks/Cte";
import Usuario from "ducks/Usuario";
import Auditoria from "ducks/Auditoria";
import Protocolos from "ducks/Protocolos";
import Pesquisar from "ducks/Pesquisar";
import Verificadas from "ducks/Verificadas";
import Rastreamento from "ducks/Rastreamento";
import EnderecoSemRota from "ducks/EnderecoSemRota";
import Notas from "ducks/Notas";
import Distribuidoras from "ducks/Distribuidoras";
import PrazoEntrega from "ducks/PrazoEntrega";
import Frete from "ducks/Frete";
import Empresas from "ducks/Empresa";

import Settings from "./Settings";
import Rota from "./Rota";
import Destinatarios from "./Destinatarios";
import Devolucoes from "./Devolucoes";

const authPersistConfig = {
    key: "auth",
    storage: storage,
    whitelist: [
        "login",
        "super_user",
        "novo_user",
        "cnpjs",
        "cpf",
        "img_perfil",
        "healthscore_CSAT",
        "healthscore_NPS",
        "v4_modules",
        "email",
        "grupo_ativo",
        "grupos",
        "bases",
        "access_token",
        "refresh_token",
    ],
};

const logoPersistConfig = {
    key: "logo",
    storage: storage,
    whitelist: ["logo"],
};

const dashboardPersistConfig = {
    key: "dashboard",
    storage: storage,
    whitelist: ["filters"],
};

const rotasPersistConfig = {
    key: "rotas",
    storage: storage,
    whitelist: ["rotaEdicao", "telaOpcao", "mostrarDestinatarios"],
};

const destinatariosPersistConfig = {
    key: "destinatarios",
    storage: storage,
    whitelist: [
        "tabelaNotas",
        "tabelaPrincipal",
        "colunasTabela",
        "tipoDestTabela",
    ],
};

const ctePersistConfig = {
    key: "Cte",
    storage: storage,
    whitelist: ["form"],
};

const formPersistConfig = {
    key: "form",
    storage: storage,
    whitelist: ["filtrosPesq", "SaveBase", "FormOpcoesRom"],
};

const RomaneiosPersistConfig = {
    key: "romaneios",
    storage: storage,
    whitelist: ["notasBusca", "romaneioEmEdicao", "agrupaDist"],
};

const protocolosPersistConfig = {
    key: "protocolos",
    storage: storage,
    whitelist: [],
};

const pesquisarPersistConfig = {
    key: "pesquisar",
    storage: storage,
    whitelist: ["filtros", "notaSele"],
};

const verificadasPersistConfig = {
    key: "verificadas",
    storage: storage,
    whitelist: ["filtros", "notaSele"],
};

const enderecosSemRotaPersistConfig = {
    key: "enderecoSemRota",
    storage: storage,
    whitelist: ["tipo"],
};

const rastreamentoPersistConfig = {
    key: "rastreamento",
    storage: storage,
    whitelist: [],
};

const notasPersistConfig = {
    key: "notas",
    storage: storage,
    whitelist: ["filtros", "notaSele"],
};

const usuarioPersistConfig = {
    key: "usuario",
    storage: storage,
    whitelist: ["basesLista"],
};

const reducers = (history) =>
    combineReducers({
        auth: persistReducer(authPersistConfig, Auth),
        logo: persistReducer(logoPersistConfig, Logo),
        dashboard: persistReducer(dashboardPersistConfig, Dashboard),
        router: connectRouter(history),
        devolucoes: Devolucoes,
        settings: Settings,
        rotas: persistReducer(rotasPersistConfig, Rota),
        motoristas: Motoristas,
        destinatarios: persistReducer(
            destinatariosPersistConfig,
            Destinatarios
        ),
        romaneios: persistReducer(RomaneiosPersistConfig, Romaneios),
        remetentes: Remetentes,
        geral: Geral,
        cte: persistReducer(ctePersistConfig, Cte),
        form: persistReducer(formPersistConfig, formReducer),
        auditoria: Auditoria,
        usuario: persistReducer(usuarioPersistConfig, Usuario),
        protocolos: persistReducer(protocolosPersistConfig, Protocolos),
        pesquisar: persistReducer(pesquisarPersistConfig, Pesquisar),
        verificadas: persistReducer(verificadasPersistConfig, Verificadas),
        enderecosSemRotas: persistReducer(
            enderecosSemRotaPersistConfig,
            EnderecoSemRota
        ),
        rastreamento: persistReducer(rastreamentoPersistConfig, Rastreamento),
        notas: persistReducer(notasPersistConfig, Notas),
        prazoEntrega: PrazoEntrega,
        distribuidoras: Distribuidoras,
        frete: Frete,
        empresa: Empresas,
    });

export default reducers;
